export default __webpack_public_path__ + "static/food-gases-bdfbb8e9d242409659753e92a056a239.png";